"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PetDetailsForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _propTypes2 = require("@PetSureAustralia/petsure-react-ui-library/distLib/propTypes");
var _objectHelpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers/objectHelpers");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _DefaultPetDetailsDisplaySettings = require("./DefaultPetDetailsDisplaySettings");
var _brandContext = require("../../contextProviders/brandContext");
var _staffInstruction = require("../StaffMode/staffInstruction");
var _useLocalSearch2 = require("../../hooks/form/useLocalSearch");
var _PreloadWrapper = require("../PreloadWrapper/PreloadWrapper");
var _selectors = require("../../store/form/selectors");
var _constants = require("../../constants/constants");
require("./petDetailsForm.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PetDetailsForm = exports.PetDetailsForm = function PetDetailsForm(_ref) {
  var _breedsBySpeciesCode, _breedsBySpeciesCode$, _petSpeciesRadios$gro;
  var petDetailsDisplaySettings = _ref.petDetailsDisplaySettings,
    isQuotePending = _ref.isQuotePending,
    petNumber = _ref.petNumber,
    _ref$includeAddAnothe = _ref.includeAddAnotherPetButton,
    includeAddAnotherPetButton = _ref$includeAddAnothe === void 0 ? false : _ref$includeAddAnothe,
    _ref$includeRemovePet = _ref.includeRemovePetButton,
    includeRemovePetButton = _ref$includeRemovePet === void 0 ? false : _ref$includeRemovePet,
    _ref$includeUndoButto = _ref.includeUndoButton,
    includeUndoButton = _ref$includeUndoButto === void 0 ? false : _ref$includeUndoButto,
    _ref$onAddAnotherPet = _ref.onAddAnotherPet,
    onAddAnotherPet = _ref$onAddAnotherPet === void 0 ? function () {} : _ref$onAddAnotherPet,
    _ref$onRemovePet = _ref.onRemovePet,
    onRemovePet = _ref$onRemovePet === void 0 ? function () {} : _ref$onRemovePet,
    _ref$onUndo = _ref.onUndo,
    onUndo = _ref$onUndo === void 0 ? function () {} : _ref$onUndo;
  var formContext = (0, _reactHookForm.useFormContext)();
  var pet = formContext.getValues("pets.".concat(petNumber)) || _propTypes2.emptyPetDetails;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.felineBreedsSelector),
    catBreeds = _useSelector.value,
    catBreedsStatus = _useSelector.status;
  var _useSelector2 = (0, _reactRedux.useSelector)(_selectors.canineBreedsSelector),
    dogBreeds = _useSelector2.value,
    dogBreedsStatus = _useSelector2.status;
  var allBreedsLoaded = catBreedsStatus === _constants.STATUS_RESOLVED && dogBreedsStatus === _constants.STATUS_RESOLVED;
  var speciesCode = (0, _reactHookForm.useWatch)({
    control: formContext.control,
    name: "pets.".concat(petNumber, ".speciesCode")
  });
  var petName = (0, _reactHookForm.useWatch)({
    control: formContext.control,
    name: "pets.".concat(petNumber, ".petName")
  });
  var breedsBySpeciesCode = (_breedsBySpeciesCode = {}, _defineProperty(_breedsBySpeciesCode, _constants.DOG_SPECIES_CODE, dogBreeds), _defineProperty(_breedsBySpeciesCode, _constants.CAT_SPECIES_CODE, catBreeds), _breedsBySpeciesCode);
  var breeds = (_breedsBySpeciesCode$ = breedsBySpeciesCode[speciesCode]) !== null && _breedsBySpeciesCode$ !== void 0 ? _breedsBySpeciesCode$ : [];
  var _useLocalSearch = (0, _useLocalSearch2.useLocalSearch)(breeds, 'description'),
    searchResults = _useLocalSearch.searchResults,
    setSearchKeyword = _useLocalSearch.setSearchKeyword;
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    staffMode = _useContext.staffMode,
    _useContext$activeBra = _useContext.activeBrandContext,
    staffInstructions = _useContext$activeBra.staffInstructions,
    productDefinitions = _useContext$activeBra.productDefinitions,
    addPetButton = _useContext$activeBra.steps.aboutPet.addPetButton;
  var customDisplaySettings = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, petDetailsDisplaySettings || {}), staffMode && staffInstructions ? staffInstructions.aboutPet : {});
  }, [petDetailsDisplaySettings, staffInstructions, staffMode]);
  var _OverrideMergeObjects = (0, _objectHelpers.OverrideMergeObjects)({
      baseObject: _DefaultPetDetailsDisplaySettings.DefaultPetDetailsDisplaySettings,
      overrideObject: customDisplaySettings
    }),
    heading = _OverrideMergeObjects.heading,
    accordionBehaviour = _OverrideMergeObjects.accordionBehaviour,
    petSpeciesRadios = _OverrideMergeObjects.petSpeciesRadios,
    petNameInput = _OverrideMergeObjects.petNameInput,
    petBreedInput = _OverrideMergeObjects.petBreedInput,
    petBirthdate = _OverrideMergeObjects.petBirthdate,
    petGenderRadios = _OverrideMergeObjects.petGenderRadios;
  var sectionHeading = (0, _react.useMemo)(function () {
    if (typeof heading === 'function') {
      return heading({
        petName: petName,
        petNumber: petNumber
      });
    }
    return "".concat(petName !== null && petName !== void 0 ? petName : 'Your pet');
  }, [petName, petNumber, heading]);
  var handlePetTypeChange = function handlePetTypeChange(species) {
    var _codeBySpecies;
    var codeBySpecies = (_codeBySpecies = {}, _defineProperty(_codeBySpecies, _constants.CAT_SPECIES, _constants.CAT_SPECIES_CODE), _defineProperty(_codeBySpecies, _constants.DOG_SPECIES, _constants.DOG_SPECIES_CODE), _codeBySpecies);
    var speciesCodeKey = "pets.".concat(petNumber, ".speciesCode");
    var speciesCode = codeBySpecies[species];
    if (formContext.getValues(speciesCodeKey) === speciesCode) {
      return;
    }
    formContext.setValue(speciesCodeKey, speciesCode);
    formContext.setValue("pets.".concat(petNumber, ".breed"), null);
  };
  var handleNameChange = function handleNameChange(event) {
    event.target.value = (0, _helpers.Capitalize)(event.target.value);
    var petName = event.target.value;
    formContext.setValue("pets.".concat(petNumber, ".petName"), petName);
  };
  var handleGenderChange = function handleGenderChange(gender) {
    var _idByGender;
    var idByGender = (_idByGender = {}, _defineProperty(_idByGender, _constants.FEMALE_GENDER, _constants.FEMALE_GENDER_ID), _defineProperty(_idByGender, _constants.MALE_GENDER, _constants.MALE_GENDER_ID), _idByGender);
    formContext.setValue("pets.".concat(petNumber, ".gender"), gender);
    formContext.setValue("pets.".concat(petNumber, ".genderId"), idByGender[gender]);
  };
  var handleBreedSearch = function handleBreedSearch(breed) {
    return setSearchKeyword(breed);
  };
  var handleBreedSelection = function handleBreedSelection(selectedBreed) {
    var _selectedBreed$isCros;
    formContext.setValue("pets.".concat(petNumber, ".breed"), selectedBreed.description);
    formContext.setValue("pets.".concat(petNumber, ".breedCode"), selectedBreed.breedCode);
    formContext.setValue("pets.".concat(petNumber, ".isCrossBreed"), (_selectedBreed$isCros = selectedBreed.isCrossBreed) !== null && _selectedBreed$isCros !== void 0 ? _selectedBreed$isCros : false);
  };
  var _useMemo = (0, _react.useMemo)(function () {
      var minAgeInDays = 0;
      var maxAgeInDays = 0;
      Object.values(productDefinitions).forEach(function (productGroup) {
        Object.values(productGroup).forEach(function (plan) {
          var limits = plan.limits;
          var _limits$ageLimits = limits.ageLimits,
            maxAgeDays = _limits$ageLimits.maxAgeDays,
            minAgeDays = _limits$ageLimits.minAgeDays;
          if (minAgeInDays > minAgeDays || minAgeInDays === 0) {
            minAgeInDays = minAgeDays;
          }
          // UPM is sending one less day than it should be, because we can't change UPM data,
          // we are adding one day here to make it correct
          minAgeInDays += 1;
          if (maxAgeInDays < maxAgeDays) maxAgeInDays = maxAgeDays;
        });
      });
      return {
        minAgeInDays: minAgeInDays,
        maxAgeInDays: maxAgeInDays
      };
    }, [productDefinitions]),
    minAgeInDays = _useMemo.minAgeInDays,
    maxAgeInDays = _useMemo.maxAgeInDays;
  return /*#__PURE__*/_react["default"].createElement(_components.SectionWrapper, {
    isFixed: accordionBehaviour,
    customCssClass: "petDetailsForm",
    heading: sectionHeading
  }, staffMode && staffInstructions && petNumber === 0 && staffInstructions.preScripts.aboutPetPreStart && staffInstructions.preScripts.aboutPetPreStart.map(function (aboutPetPreStartInstruction, index) {
    return /*#__PURE__*/_react["default"].createElement(_staffInstruction.StaffInstruction
    // eslint-disable-next-line react/no-array-index-key
    , _extends({
      key: "aboutPetPreStartInstruction".concat(index),
      instructionKey: "aboutPetPreStartInstruction"
    }, aboutPetPreStartInstruction));
  }), /*#__PURE__*/_react["default"].createElement(_PreloadWrapper.PreloadWrapper, {
    isLoading: isQuotePending
  }, /*#__PURE__*/_react["default"].createElement(_components.AnimalRadios, _extends({
    fieldFormContext: formContext,
    required: true,
    value: pet.species,
    groupName: "pets.".concat(petNumber, ".species"),
    onChange: function onChange(event) {
      return handlePetTypeChange(event);
    }
  }, petSpeciesRadios, {
    name: "pets.".concat(petNumber, ".species"),
    groupLabel: (_petSpeciesRadios$gro = petSpeciesRadios.groupLabel({
      petName: petName
    })) !== null && _petSpeciesRadios$gro !== void 0 ? _petSpeciesRadios$gro : ''
  }))), /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    fieldFormContext: formContext,
    autoComplete: "off",
    defaultValue: pet.petName,
    maxLength: 30,
    customChangeHandler: function customChangeHandler(event) {
      return handleNameChange(event);
    }
  }, petNameInput, {
    name: "pets.".concat(petNumber, ".petName"),
    label: petNameInput.label({
      gender: pet.gender,
      petName: pet.petName
    })
  })), /*#__PURE__*/_react["default"].createElement(_components.BreedAutoComplete, _extends({
    showSpinner: isQuotePending || !allBreedsLoaded,
    fieldFormContext: formContext,
    defaultValue: pet.breedCode,
    disabled: !speciesCode,
    onSelectWithData: function onSelectWithData(event) {
      return handleBreedSelection(event);
    },
    onSearch: function onSearch(event) {
      return handleBreedSearch(event);
    }
  }, petBreedInput, {
    searchResults: searchResults,
    name: "pets.".concat(petNumber, ".breed"),
    label: petBreedInput.label(pet.petName)
  })), /*#__PURE__*/_react["default"].createElement(_components.AnimalBirthdate, _extends({
    fieldFormContext: formContext,
    defaultValue: (0, _helpers.IsValidDate)(pet.petDOB) ? (0, _helpers.DateToShortIsoString)(pet.petDOB) : ''
  }, petBirthdate, {
    name: "pets.".concat(petNumber, ".petDOB"),
    label: petBirthdate.label(pet.petName),
    minAgeInDays: minAgeInDays,
    maxAgeInDays: maxAgeInDays
  }))), /*#__PURE__*/_react["default"].createElement(_PreloadWrapper.PreloadWrapper, {
    isLoading: isQuotePending
  }, /*#__PURE__*/_react["default"].createElement(_components.StyledRadios, _extends({
    fieldFormContext: formContext,
    groupName: "pets.".concat(petNumber, ".gender"),
    required: true,
    onChange: function onChange(event) {
      return handleGenderChange(event);
    },
    value: pet.gender
  }, petGenderRadios, {
    name: "pets.".concat(petNumber, ".gender"),
    groupLabel: petGenderRadios.groupLabel(pet.petName)
  }))), includeAddAnotherPetButton && staffMode && staffInstructions && staffInstructions.aboutPet.addAPetButton && /*#__PURE__*/_react["default"].createElement(_staffInstruction.StaffInstruction, _extends({}, staffInstructions.aboutPet.addAPetButton, {
    instructionKey: "addAPetButton"
  })), /*#__PURE__*/_react["default"].createElement("footer", null, includeRemovePetButton && /*#__PURE__*/_react["default"].createElement("button", {
    id: "".concat(petNumber, "_removePetButton"),
    className: "button removePet",
    type: "button",
    onClick: function onClick() {
      return onRemovePet(petNumber);
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "minus"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Remove ", pet.petName || 'pet')), includeAddAnotherPetButton && /*#__PURE__*/_react["default"].createElement("button", {
    id: "".concat(petNumber, "_addPetButton"),
    className: "button addPet",
    type: "button",
    onClick: function onClick() {
      return onAddAnotherPet();
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "plus"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, addPetButton.label)), includeUndoButton && /*#__PURE__*/_react["default"].createElement("button", {
    id: "".concat(petNumber, "_undoButton"),
    className: "button undo",
    type: "button",
    onClick: function onClick() {
      return onUndo();
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "undo"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Undo"))));
};
PetDetailsForm.propTypes = {
  /* eslint-disable-next-line react/forbid-prop-types */
  petDetailsDisplaySettings: _propTypes["default"].shape(_propTypes2.PetDetailsFormDisplaySettingsPropTypes),
  isQuotePending: _propTypes["default"].bool,
  petNumber: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  includeAddAnotherPetButton: _propTypes["default"].bool,
  includeRemovePetButton: _propTypes["default"].bool,
  includeUndoButton: _propTypes["default"].bool,
  onAddAnotherPet: _propTypes["default"].func,
  onRemovePet: _propTypes["default"].func,
  onUndo: _propTypes["default"].func
};
var _default = exports["default"] = PetDetailsForm;